import '.a3{position:fixed;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.fv{bottom:0px;}.ssr-plugin'
import '.gv{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gw{z-index:998;}.ssr-plugin'
import '.gx{transition:opacity 0.3s ease;}.ssr-plugin'
import '.x{height:100vh;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.gy{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gz{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.c1{padding:1.5rem;}.ssr-plugin'
import '.h0{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bu{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a3 cg bi bj fv gv gw gx"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a3 cg x a8 ae gy gz a e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a f a9 c1 h0 bn"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bu at c1"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
